import script from "./UpgradeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeItem.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeItem.vue?vue&type=style&index=0&id=241f4376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-241f4376"]])

export default __exports__